import { useGlobalStateContext } from './globalState';
/**
 * Hook that gets an action for manipulating the global state.
 * @param action The name of the action to retrieve.
 */
export function useAction(action) {
    const ctx = useGlobalStateContext();
    return ctx[action];
}
//# sourceMappingURL=action.js.map